var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wp-debug-tool" },
    [
      _c(
        "a-descriptions",
        { attrs: { title: "", layout: "vertical", bordered: "" } },
        [
          _c("a-descriptions-item", { attrs: { label: "Product" } }, [
            _vm._v(" " + _vm._s(_vm.getPlanName())),
          ]),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: "Health Status" } },
            [
              _vm.isHealthy
                ? _c("a-badge", {
                    attrs: { status: "success", text: "Healthy" },
                  })
                : _c("a-badge", {
                    attrs: { status: "error", text: "Not Healthy" },
                  }),
            ],
            1
          ),
          _vm._v(" "),
          _c("a-descriptions-item", { attrs: { label: "Whatsapp Name" } }, [
            _vm._v(_vm._s(_vm.getVerifiedName())),
          ]),
          _vm._v(" "),
          _c(
            "a-descriptions-item",
            { attrs: { label: "Whatsapp Number", span: 3 } },
            [_vm._v(" " + _vm._s(_vm.getPhoneNumber()))]
          ),
          _vm._v(" "),
          _c("a-descriptions-item", { attrs: { label: "Actions", span: 4 } }, [
            _c("div", { staticClass: "debug-buttons-container" }, [
              _c(
                "div",
                { staticClass: "buttons" },
                [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("getMe")
                        },
                      },
                    },
                    [_vm._v(" GET ME")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("getConnectionState")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        GET CONNECTION STATE\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("getHostNumber")
                        },
                      },
                    },
                    [_vm._v(" GET HOST NUMBER")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("getStatus")
                        },
                      },
                    },
                    [_vm._v(" GET STATUS")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("kill")
                        },
                      },
                    },
                    [_vm._v(" KILL")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "danger", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("reset")
                        },
                      },
                    },
                    [_vm._v(" RESET")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("refresh")
                        },
                      },
                    },
                    [_vm._v(" REFRESH")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("syncContacts")
                        },
                      },
                    },
                    [_vm._v(" SYNC CONTACTS")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("getWAVersion")
                        },
                      },
                    },
                    [_vm._v(" WA VERSION")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("healthCheck")
                        },
                      },
                    },
                    [_vm._v(" HEALTH CHECK")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("gc")
                        },
                      },
                    },
                    [_vm._v(" RUN GC")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "primary", ghost: "" },
                      on: {
                        click: function ($event) {
                          return _vm.sendRequest("emitUnreadMessages")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                        GET UNREAD MESSAGES\n                    "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "response" }, [
                _c("span", { staticClass: "title" }, [_vm._v("RESPONSE")]),
                _vm._v(" "),
                _vm.busy
                  ? _c("span", { staticClass: "content" }, [
                      _vm._v(" Waiting .... "),
                    ])
                  : _c(
                      "div",
                      { staticClass: "content" },
                      [
                        _c("prism-editor", {
                          staticClass: "my-editor",
                          attrs: { highlight: _vm.highlighter, readonly: "" },
                          model: {
                            value: _vm.response,
                            callback: function ($$v) {
                              _vm.response = $$v
                            },
                            expression: "response",
                          },
                        }),
                      ],
                      1
                    ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }